var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-card"},[_c('div',{staticClass:"chart-card-title"},[_vm._v(" "+_vm._s(_vm.$t('commons.standards.gender'))+" ")]),_c('span',{staticClass:"chart-card-subtitle"},[_vm._v(_vm._s(_vm.$t(_vm.gender)))])])}
var staticRenderFns = []

export { render, staticRenderFns }